/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChevronLargeLeftIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAmElEQVR4nGNgGAW0AD4+kSK+/uEnfQMiDtLEcL+A8It+ARH//fwjjlPVcI/QUFG44QHhF0GW0cRwX/+Ia16hoRI0MdzPP/z6qOG0DxYQ8A0IPwGO0ICIq76+EeIM1AY0t8DbO0rQNyD8DNSSG4GB0ZKjlhAVXH7+4ddpHlx+Q9oSH6Timib1AdwS//C9vgER88ACo4CBAgAAJ+d91KFxMWoAAAAASUVORK5CYII=)
 */
export const ChevronLargeLeftIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.7 3.3a1 1 0 0 1 0 1.4L8.42 12l7.3 7.3a1 1 0 0 1-1.42 1.4l-8-8a1 1 0 0 1 0-1.4l8-8a1 1 0 0 1 1.42 0Z"
        className={colorClass}
      />
    </svg>
  );
};
